////////////////////////////////////////////////accordion
if (!customElements.get("dl-js-accordion")) {
  class DL_Accordion extends HTMLElement {
    constructor() {
      super();
      this.wrap = this.querySelectorAll(".dl-js-accordion__wrap");
      this.head = this.querySelectorAll(".dl-js-accordion__head");
      this.body = this.querySelectorAll(".dl-js-accordion__body");
      this.targetHead = null;
      this.targetBody = null;
      window.addEventListener('load', () => {
        this.head.forEach(head => {
          if (DL_hasClass(head, "is-active")) {
            this.targetHead = head;
            this.targetBody = head.closest(".dl-js-accordion__wrap").querySelector(".dl-js-accordion__body");
            this.open();
          }
        });
      });
      this.event();
    }
    event() {
      this.wrap.forEach(wrap => {
        wrap.addEventListener('click', (e) => {
          this.targetHead = wrap.querySelector(".dl-js-accordion__head");
          this.targetBody = wrap.querySelector(".dl-js-accordion__body");
          if (DL_hasClass(this.targetHead, "is-active")) {
            if (!e.target.closest("a")) {
              this.close();
            }
          } else {
            this.open();
          }
        });
      });

    }
    close() {
      DL_removeClass(this.targetHead, "is-active");
      this.targetBody.style.maxHeight = null;
    }
    open() {
      DL_addClass(this.targetHead, "is-active");
      this.targetBody.style.maxHeight = this.targetBody.scrollHeight + "px";
    }
  }
  customElements.define("dl-js-accordion", DL_Accordion);
}